import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Users, Target, Heart, Sparkles, Zap, Shield, Globe } from 'lucide-react';

export default function CompanyTeam() {
  return (
    <SubpageTemplate 
      title="Our Team"
      subtitle="The Builders"
      description="Yacht Labs is a remote-first team of polymaths, engineers, and designers obsessed with shortening the distance between idea and existence."
      icon={Users}
      features={[
        {
          title: "Engineering Excellence",
          description: "Our core team comes from background in LLM research and distributed systems.",
          icon: Zap
        },
        {
          title: "Design-First",
          description: "We believe the tool should be as beautiful as the products it builds.",
          icon: Sparkles
        },
        {
          title: "Global Roots",
          description: "A diverse team operating across 12 countries and 8 time zones.",
          icon: Globe
        }
      ]}
    />
  );
}
